import "@app/App.css";
import { Label } from "@comps/ui/label";
import { Switch } from "@comps/ui/switch";
import { GRAY_300_COLOR } from "@utils/colors";
import { SHOW_ALL_LINES } from "@utils/constants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataStore, useModelStore } from "src/store";

interface ShowAllLinesButtonProps {
}

function ShowAllLinesButton({ }: ShowAllLinesButtonProps) {

  const [showAllLines, setShowAllLines] = useState(true);
  const selectedObjectInfos = useModelStore((state) => state.selectedObjectInfos);
  const wsColor = useModelStore((state) => state.wsColor);
  const fetchView = useDataStore((state) => state.fetchView);
  const { t } = useTranslation();
  const fields = selectedObjectInfos?.fields;
  const rowActionsEnabled = useDataStore(state => state.rowActionsEnabled);

  useEffect(() => {
    const showAllLines = localStorage.getItem(SHOW_ALL_LINES + selectedObjectInfos?.object._key);
    if (showAllLines !== null) {
      setShowAllLines(showAllLines === "true");
    }
  }, [selectedObjectInfos]);

  const onShowAllLinesChange = (value: boolean) => {
    setShowAllLines(value);
    localStorage.setItem(SHOW_ALL_LINES + selectedObjectInfos?.object._key, value.toString());
    fetchView(null);
  }

  const disabled = !fields || !rowActionsEnabled;
  return (
    <div className="flex flex-row justify-start items-center gap-2 w-max px-2 py-1">
      <Label className={"w-max overflow-hidden text-ellipsis whitespace-nowrap leading-2 " + (!disabled ? " opacity-100" : " opacity-50")}>{t("object.header.button.show.all.lines.title")}</Label>
      <Switch id="show-all-lines" disabled={disabled} checked={showAllLines} onCheckedChange={onShowAllLinesChange} style={{ backgroundColor: (showAllLines ? wsColor : GRAY_300_COLOR) }} />
    </div>
  )
}

export default ShowAllLinesButton;
